import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays the spec of the selected variant.
 * The markup is rendered server-side from the variant metafields; this component swaps
 * it for the freshly rendered one carried by the variant update event.
 */
class VariantSpec extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSpec);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSpec);
  }

  /**
   * Updates the spec.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSpec = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpec = event.detail.data.html.querySelector('variant-spec [ref="specContainer"]');
    const currentSpec = this.querySelector('[ref="specContainer"]');

    if (!newSpec || !currentSpec) return;

    if (currentSpec.innerHTML !== newSpec.innerHTML) {
      currentSpec.replaceWith(newSpec);
    }
  };
}

if (!customElements.get('variant-spec')) {
  customElements.define('variant-spec', VariantSpec);
}
